function getCurrentDomain () {
  let temp = window.location.hostname.split('.')
  if (temp.length > 1) {
    return temp[+temp.length - 2]
  } else {
    return temp[0]
  }
}

function getLastSiteId () {
  return localStorage.getItem('chekt::lastSiteId')
}
function setLastSiteId (siteId) {
  return localStorage.setItem('chekt::lastSiteId', siteId)
}
function getLastEmail () {
  return localStorage.getItem('chekt::lastEmail')
}
function setLastEmail (email) {
  return localStorage.setItem('chekt::lastEmail', email)
}
function getCamerasLastZoomIndex () {
  return localStorage.getItem('chekt::camerasLastZoomIndex')
}
function setCamerasLastZoomIndex (index) {
  return localStorage.setItem('chekt::camerasLastZoomIndex', index)
}

var environment = {
  currentDomain: getCurrentDomain(),
  isProduction: null,
  isChektDomain: null,
  authClientID: null,
  authDomain: null,
  authConnection: null,
  authScope: null,
  authCookieDomain: null,
  authTargetPath: null,
  apiTargetPath: null,
  apiPrefix: null,
  operationWebUrl: null,
  dealerWebUrl: null,
  monitoringWebUrl: null,
  shareWebUrl: null,
  appWebUrl: null,
  getLastSiteId: getLastSiteId,
  setLastSiteId: setLastSiteId,
  getLastEmail: getLastEmail,
  setLastEmail: setLastEmail,
  getCamerasLastZoomIndex: getCamerasLastZoomIndex,
  setCamerasLastZoomIndex: setCamerasLastZoomIndex
}

if (environment.currentDomain === 'chekt') {
  environment.isChektDomain = true
  environment.isProduction = true
} else if (environment.currentDomain === 'chektdev') {
  environment.isChektDomain = true
  environment.isProduction = false
} else if (environment.currentDomain === 'github') {
  environment.isChektDomain = false
  environment.isProduction = false
} else if (environment.currentDomain === 'firebaseapp') {
  environment.isChektDomain = false
  environment.isProduction = false
} else if (environment.currentDomain === 'localhost') {
  environment.isChektDomain = false
  environment.isProduction = true
} else {
  environment.isChektDomain = false
  environment.isProduction = false
}

if (environment.isProduction) {
  environment.authClientID = 'bHzjpwmWpjwdOukz2h7FM2u2ND5BPKFa'
  environment.authDomain = 'chektcloud.auth0.com'
  environment.authConnection = 'Username-Password-Authentication'
  environment.authScope = 'openid offline_access'
  environment.authCookieDomain = '.chekt.com'
  environment.authTargetPath = 'account.chekt.com'
  environment.apiTargetPath = 'api.chekt.com'
  environment.apiPrefix = '/api/v1.1'
  environment.mqttTargetPath = 'nexus.chekt.com'
  environment.mqttTargetPathPort = 443
  environment.operationWebUrl = 'https://operation.chekt.com'
  environment.dealerWebUrl = 'https://dealer.chekt.com'
  environment.monitoringWebUrl = 'https://monitoring.chekt.com'
  environment.shareWebUrl = 'https://share.chekt.com'
  environment.appWebUrl = 'https://app.chekt.com'
} else {
  environment.authClientID = 'yeJIohNks41mYAiaID29JoxsZESOpEQ8'
  environment.authDomain = 'chektdev.auth0.com'
  environment.authConnection = 'Username-Password-Authentication'
  environment.authScope = 'openid offline_access'
  environment.authCookieDomain = '.chektdev.com'
  environment.authTargetPath = 'account.chektdev.com'
  environment.apiTargetPath = 'api.chektdev.com'
  environment.apiPrefix = '/api/v1.1'
  environment.mqttTargetPath = 'commandcenter.chektdev.com'
  environment.mqttTargetPathPort = 443
  environment.operationWebUrl = 'https://operation.chektdev.com'
  environment.dealerWebUrl = 'https://dealer.chektdev.com'
  environment.monitoringWebUrl = 'https://monitoring.chektdev.com'
  environment.shareWebUrl = 'https://share.chektdev.com'
  environment.appWebUrl = 'https://app.chektdev.com'
}

export default environment



// WEBPACK FOOTER //
// ./src/services/environment.js